import { type User } from '@/db/types';
import { cn } from '@/lib/classnames';
import { RARITY } from '@/constants';
import { squishiesById } from '@/squishy.data';
import styles from './catch-counter.module.css';

const aggregate = (catches: User['catches']) => {
  const rarityMap = new Map<RARITY, number>(
    Object.values(RARITY).map(rarity => [rarity, 0])
  );
  for (const [id, quantity] of catches.entries()) {
    if (!squishiesById.has(id)) continue;

    const rarity = squishiesById.get(id)!.rarity;
    if (!rarity) continue;

    rarityMap.set(rarity, (rarityMap.get(rarity) || 0) + quantity);
  }
  return rarityMap;
};

export const CatchCounter = ({
  catches,
  className,
}: {
  catches: User['catches'],
  className?: string;
}) => (
  <span
    className={ cn(styles.counter, className) }
    data-component="catch-counter"
  >
    { Array.from(aggregate(catches).entries()).map(([rarity, quantity]) => (
      <span key={ rarity }>
        { quantity }
      </span>
    )) }
  </span>
);